//EditWorkFlowService.ts
import axios from 'axios';
import { axiosRequest } from './AxiosService';
import { EditWorkFlowResponseList,EditWorkFlowResponse } from '../type/response/EditWorkFlowResponse';  
import { WorkFlowType } from '../pages/EditWorkFlow/data/WorkFlowType';

/**
 * ワークフロー一覧データを取得し、表示用の形式に変換して返す
 * @returns ワークフロー一覧データ、取得失敗時は空配列
 */
export const getWorkFlows = async (): Promise<WorkFlowType[]> => {
  try {
    const response = await axiosRequest<EditWorkFlowResponseList>(
      "/workFlows", 
      "GET"
    );

    // 取得したデータのフォーマット化
    const formattedWorkFlows: WorkFlowType[] = response.map((editWorkFlowResponse: EditWorkFlowResponse) => {
      const formattedWorkFlow: WorkFlowType = {
        applicationId: editWorkFlowResponse.application.id,
        code:editWorkFlowResponse.application.code,
        version:editWorkFlowResponse.application.version,
        name:editWorkFlowResponse.application.name,
        description:editWorkFlowResponse.application.description,
        type:editWorkFlowResponse.applicationType.name,
        isDeleted:editWorkFlowResponse.application.isDeleted,
        isDraft:editWorkFlowResponse.application.isDraft
      };

      return formattedWorkFlow;
    });

    return formattedWorkFlows;

  } catch (error) {
    console.error("ワークフロー一覧データの取得・整形に失敗しました:", error);
    return []; 
  }
};